<template>
  <div id="sem-permissao" class="sem-permissao">
    <div
      class="estado-vazio estado-vazio_largura-grande sem-permissao__conteudo"
    >
      <i class="far fa-lock estado-vazio__icone"></i>
      <h2 class="estado-vazio__titulo">Acesso negado</h2>
      <p class="estado-vazio__texto">
        Você não possui permissão para acessar o Controle de Saldo.
        <br />
        Entre em contato com o administrador do sistema para solicitar o seu
        acesso.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemPermissao',
};
</script>

<style lang="scss" scoped>
.sem-permissao {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 96px);
}

.sem-permissao__conteudo {
  min-height: auto;
}
</style>



// WEBPACK FOOTER //
// SemPermissao.vue?7a8a2f60